import { ColumnTypes } from '../';

export const getColumns = (): ColumnTypes => [
	{
		title: `사업장`,
		dataIndex: 'franchiseName',
		key: 'franchiseName',
		align: 'center',
	},
	{
		title: '배정 일자',
		dataIndex: 'workEndDate',
		key: 'workEndDate',
		align: 'center',
	},
	{
		title: '비고',
		dataIndex: 'memo',
		key: 'memo',
		align: 'center',
	},
];

export const HEADER_HEIGHT = 40;
export const TH_HEIGHT = 48;
export const TR_HEIGHT = 52;
